// index.js
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { Router } from '@reach/router'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import Dashboard from './components/presentation/dashboard'
import AllCustomersInfoWidget from './components/container/all-customers-info-widget'
import CustomerDashboardWidget from './components/container/customer-dashboard-widget'
import GeneralStats from './components/GeneralStats'
import CreateAccountWidget from './components/container/create-account-widget'
import Login from './components/Login'
import CreateAdminUserWidget from './components/container/create-admin-user-widget'
import CustomerTools from './components/Tools'
import CustomerInformation from './components/presentation/customer-information'
import CustomerProjectsWidget from './components/container/customer-projects-widget'
import CustomerReportsWidget from './components/container/customer-reports-widget'
import CustomerSSOWidget from './components/container/customer-sso-widget'
import ProjectConfigWidget from './components/container/project-config-widget'
import BlueConnectUsersNavBar from "./components/BlueConnectUsersNavBar";
import SuperUserList from "./components/SuperUserList";
import PrivateRoute from './components/private-route'
import CheckinsReport from './components/CheckinsReport'
import ImportZones from './components/ImportZones'
import Visualisations from './components/Visualisations'
import CreateCartoMap from './components/Visualisations/components/CreateNewMap'
import Simulators from './components/Simulators'
import CustomerFeatureToggle from './components/CustomerFeatureToggle'
import GenerateWaveAppUrl from './components/GenerateAppUrlComponents/GenerateWaveAppUrl'
import TempoConfiguration from './components/TempoConfiguration'
import ConfigureHelloTtl from "./components/ConfigureHelloTtl";
import TempoTimeBracketsConfig from './components/TempoConfiguration/components/TimeBracketsConfig'
import NowReadyProjectSelector from "./components/NowReady/NowReadyProjectSelector";
import NowReadyConfiguration from "./components/NowReady/NowReadyConfigurationWrapper";
import GenerateNowReadyDemoUrl from "./components/GenerateAppUrlComponents/GenerateNowReadyDemoUrl";
import HelloConfig from "./components/HelloConfig";
import { AuthenticationContext } from './components/contexts/authentication-context'
import CssBaseline from '@material-ui/core/CssBaseline'

require('babel-polyfill')

// Material UI Theme
const theme = createMuiTheme({
    palette: {
        primary: { main: '#429BD5' },
    },
    typography: {
        subtitle1: {
            fontSize: '1.2rem',
        },
    },
})

const MainInterface = () => {
    const [isUserAuthenticated, setIsUserAuthenticated] = useState(false)
    const value = { isUserAuthenticated, setIsUserAuthenticated }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthenticationContext.Provider value={value}>
                <Router>
                    <Login default path="/login" setIsUserAuthenticated={setIsUserAuthenticated} />
                    <PrivateRoute path="/" as={Dashboard}>
                        <PrivateRoute path="/" as={AllCustomersInfoWidget} />

                        <PrivateRoute
                            path="/allCustomers/:search/:sortBy/:sortAsc/:showDeleted"
                            as={AllCustomersInfoWidget}
                        />
                        <PrivateRoute path="/users" as={BlueConnectUsersNavBar}>
                            <PrivateRoute path="/superUserList" as={SuperUserList} />
                            <PrivateRoute path="/createAdminUser" as={CreateAdminUserWidget} />
                        </PrivateRoute>
                        <PrivateRoute path="/createAccount" as={CreateAccountWidget} />
                        <PrivateRoute path="/generalStats" as={GeneralStats} />
                        <PrivateRoute path="/customer/:id" as={CustomerDashboardWidget}>
                            <PrivateRoute path="/" as={CustomerInformation} />
                            <PrivateRoute path="/projects" as={CustomerProjectsWidget} />
                            <PrivateRoute path="/tools" as={CustomerTools} />
                            <PrivateRoute path="/reports" as={CustomerReportsWidget} />
                            <PrivateRoute path="/project/:projectId" as={ProjectConfigWidget} />
                            <PrivateRoute path="/checkinsReport" as={CheckinsReport} />
                            <PrivateRoute path='/importZones' as={ImportZones} />
                            <PrivateRoute path='/visualisations' as={Visualisations} />
                            <PrivateRoute path="/visualisations/create" as={CreateCartoMap} />
                            <PrivateRoute path='/simulators' as={Simulators} />
                            <PrivateRoute path="/features" as={CustomerFeatureToggle} />
                            <PrivateRoute path="/tempoConfiguration" as={TempoConfiguration}/>
                            <PrivateRoute path="/helloTtl" as={ConfigureHelloTtl}/>
                            <PrivateRoute path="/tempoConfiguration/:projectId" as={TempoTimeBracketsConfig}/>
                            <PrivateRoute path="/generateWaveAppUrl" as={GenerateWaveAppUrl}/>
                            <PrivateRoute path="/nowReady" as={NowReadyProjectSelector}/>
                            <PrivateRoute path="/nowReady/:projectId" as={NowReadyConfiguration}/>
                            <PrivateRoute path="/nowReadyDemo" as={GenerateNowReadyDemoUrl}/>
                            <PrivateRoute path="/helloConfiguration" as={HelloConfig}/>
                        </PrivateRoute>
                    </PrivateRoute>
                    <PrivateRoute path="/customer/:id/sso" as={CustomerSSOWidget} />
                </Router>
            </AuthenticationContext.Provider>
        </ThemeProvider>
    )
}

ReactDOM.render(<MainInterface />, document.getElementById('mainContent'))
